import { CircularProgress } from "@mui/material";
import CommunityLogo from "./community-logo";
import { Community } from "../utils/commsParser";

const HEADING = "Joining communities based on your selection!";
export const LOGOS_TO_SHOW = 5;

interface CommunityOnboardingLoadingProps {
    selectedCommunties: Community[];
}

const CommunityOnboardingLoading: React.FC<CommunityOnboardingLoadingProps> = ({
    selectedCommunties,
}) => {
    const otherCommuCount = selectedCommunties?.length - LOGOS_TO_SHOW;
    return (
        <div className="flex h-screen w-full flex-col items-center justify-center px-[32px] text-[#190A28]">
            <div className="flex flex-col items-center justify-center gap-[8px]">
                <div className="flex justify-center text-center text-[20px] font-bold">
                    {HEADING}
                </div>
            </div>
            <div className="mt-[100px] mb-[100px] flex flex-col items-center justify-center">
                <CommunityLogo
                    size={48}
                    selectedCommunties={selectedCommunties}
                    margin={-18}
                />
                {otherCommuCount > 0 && (
                    <div className="mt-[16px] text-[16px] font-[400] text-[#8C8594]">{`& ${otherCommuCount} more`}</div>
                )}
            </div>
            <div className="loader">
                <CircularProgress
                    className="!h-[48px] !w-[48px]"
                    sx={{ color: "#1F8268" }}
                />
            </div>
        </div>
    );
};

export default CommunityOnboardingLoading;
